import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow } from "vue"

const _hoisted_1 = {
  class: "meeting-page",
  ref: "pageRoot"
}
const _hoisted_2 = {
  key: 0,
  class: "meeting-capture-saved",
  role: "alert"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "meeting-capture-saved",
  role: "status"
}
const _hoisted_5 = { class: "meeting-groupbar" }
const _hoisted_6 = ["onClick", "onContextmenu"]
const _hoisted_7 = {
  key: 0,
  class: "meeting-menu group-add"
}
const _hoisted_8 = {
  key: 1,
  class: "meeting-tabbar"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "meeting-tab-badge" }
const _hoisted_11 = { class: "meeting-menu new-meeting-add" }
const _hoisted_12 = { class: "meeting-menu past-meetings" }
const _hoisted_13 = {
  key: 0,
  class: "meeting-menu-empty"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "meeting-menu-color" }
const _hoisted_16 = { class: "meeting-menu-head" }
const _hoisted_17 = { class: "meeting-menu-color" }
const _hoisted_18 = {
  key: 0,
  class: "meeting-menu-empty"
}
const _hoisted_19 = {
  key: 1,
  class: "meeting-menu-empty"
}
const _hoisted_20 = {
  key: 2,
  class: "meeting-menu-list"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "meeting-menu-item-name" }
const _hoisted_23 = { class: "meeting-menu-item-date" }
const _hoisted_24 = { class: "meeting-menu-head" }
const _hoisted_25 = { class: "meeting-menu-list" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "meeting-template-text" }
const _hoisted_28 = { class: "meeting-template-name" }
const _hoisted_29 = {
  key: 0,
  class: "meeting-template-desc"
}
const _hoisted_30 = {
  key: 7,
  class: "meeting-empty-state"
}
const _hoisted_31 = { class: "run-meeting-bar" }
const _hoisted_32 = { class: "run-meeting-bar-left" }
const _hoisted_33 = { class: "run-meeting-title" }
const _hoisted_34 = { class: "run-meeting-stat" }
const _hoisted_35 = { class: "run-meeting-stat-label" }
const _hoisted_36 = { class: "run-meeting-stat" }
const _hoisted_37 = { class: "run-meeting-stat-time" }
const _hoisted_38 = { class: "run-meeting-desc" }
const _hoisted_39 = { class: "run-meeting-desc-name" }
const _hoisted_40 = { class: "run-meeting-desc-text" }
const _hoisted_41 = { class: "run-meeting-bar-right" }
const _hoisted_42 = {
  key: 3,
  class: "run-meeting-btn run-meeting-btn-end disable-button"
}
const _hoisted_43 = { class: "run-meeting-sections run-meeting-sections-fill" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "run-meeting-section-top" }
const _hoisted_46 = { class: "run-meeting-section-num" }
const _hoisted_47 = { class: "run-meeting-section-min" }
const _hoisted_48 = { class: "run-meeting-section-name" }
const _hoisted_49 = {
  key: 1,
  class: "meeting-head"
}
const _hoisted_50 = {
  key: 0,
  class: "meeting-past-banner"
}
const _hoisted_51 = { class: "meeting-head-top" }
const _hoisted_52 = {
  key: 0,
  class: "meeting-bigdate"
}
const _hoisted_53 = { class: "meeting-bigdate-dow" }
const _hoisted_54 = { class: "meeting-bigdate-md" }
const _hoisted_55 = { class: "meeting-head-title" }
const _hoisted_56 = { class: "meeting-head-name" }
const _hoisted_57 = {
  key: 0,
  class: "meeting-private-pill"
}
const _hoisted_58 = {
  key: 2,
  class: "meeting-avatars"
}
const _hoisted_59 = ["title"]
const _hoisted_60 = ["title"]
const _hoisted_61 = { class: "meeting-head-meta" }
const _hoisted_62 = { class: "meeting-recur" }
const _hoisted_63 = { class: "meeting-length-box" }
const _hoisted_64 = { class: "meeting-total-length" }
const _hoisted_65 = { class: "meeting-head-actions" }
const _hoisted_66 = { class: "meeting-subtabs" }
const _hoisted_67 = { class: "meeting-head-btns" }
const _hoisted_68 = { class: "meeting-wrap" }
const _hoisted_69 = { class: "meeting-recap-card" }
const _hoisted_70 = { class: "meeting-recap-title" }
const _hoisted_71 = { class: "meeting-recap-meta" }
const _hoisted_72 = { class: "meeting-recap-attendees" }
const _hoisted_73 = {
  key: 0,
  class: "meeting-recap-col"
}
const _hoisted_74 = { class: "meeting-recap-col-header" }
const _hoisted_75 = { class: "meeting-recap-item-row" }
const _hoisted_76 = { class: "meeting-recap-item-name" }
const _hoisted_77 = {
  key: 0,
  class: "meeting-private",
  title: "Only visible to you"
}
const _hoisted_78 = {
  key: 0,
  class: "meeting-recap-item-assignee"
}
const _hoisted_79 = {
  key: 0,
  class: "meeting-recap-item-comments"
}
const _hoisted_80 = { class: "meeting-recap-item-comment-author" }
const _hoisted_81 = {
  key: 1,
  class: "meeting-recap-empty"
}
const _hoisted_82 = {
  key: 0,
  class: "meeting-empty-state"
}
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { class: "meeting-history-date" }
const _hoisted_85 = { class: "meeting-history-main" }
const _hoisted_86 = { class: "meeting-history-title" }
const _hoisted_87 = { class: "meeting-history-meta" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "meeting-history-links" }
const _hoisted_90 = {
  key: 0,
  class: "run-meeting-panel"
}
const _hoisted_91 = { class: "run-meeting-panel-h" }
const _hoisted_92 = {
  key: 1,
  class: "run-meeting-panel"
}
const _hoisted_93 = { class: "run-meeting-panel-h" }
const _hoisted_94 = {
  key: 3,
  class: "meeting-progress"
}
const _hoisted_95 = { class: "meeting-progress-label" }
const _hoisted_96 = ["aria-valuenow"]
const _hoisted_97 = { class: "meeting-progress-pct" }
const _hoisted_98 = {
  key: 4,
  class: "kanban"
}
const _hoisted_99 = { class: "kanban-colh" }
const _hoisted_100 = { style: {"flex":"1"} }
const _hoisted_101 = ["onClick"]
const _hoisted_102 = { class: "kanban-colcnt" }
const _hoisted_103 = { class: "kanban-colb" }
const _hoisted_104 = ["onClick"]
const _hoisted_105 = { class: "meeting-card-title" }
const _hoisted_106 = ["checked", "title", "onChange"]
const _hoisted_107 = { class: "meeting-card-footer" }
const _hoisted_108 = {
  key: 2,
  class: "meeting-private",
  title: "Only visible to you"
}
const _hoisted_109 = ["title"]
const _hoisted_110 = ["title"]
const _hoisted_111 = ["title"]
const _hoisted_112 = {
  key: 6,
  class: "meeting-owner"
}
const _hoisted_113 = ["onClick"]
const _hoisted_114 = ["onClick"]
const _hoisted_115 = { class: "run-end slide-up" }
const _hoisted_116 = { class: "run-end-head" }
const _hoisted_117 = { class: "run-end-meta" }
const _hoisted_118 = { class: "run-end-body" }
const _hoisted_119 = { class: "run-end-h" }
const _hoisted_120 = {
  key: 0,
  class: "run-end-todos"
}
const _hoisted_121 = ["onClick"]
const _hoisted_122 = { class: "run-end-todo-name" }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = {
  key: 1,
  class: "run-end-todo-due"
}
const _hoisted_125 = {
  class: "run-end-rates",
  role: "radiogroup",
  "aria-label": "Meeting rating"
}
const _hoisted_126 = ["aria-checked", "onClick"]
const _hoisted_127 = {
  key: 0,
  class: "run-end-foot"
}
const _hoisted_128 = { class: "run-end-btns" }
const _hoisted_129 = {
  key: 1,
  class: "run-end-foot"
}
const _hoisted_130 = { class: "run-end-last" }
const _hoisted_131 = { class: "run-end-btns" }
const _hoisted_132 = ["title"]
const _hoisted_133 = {
  key: 13,
  class: "error-msg-wrap"
}
const _hoisted_134 = { class: "form-wrapper slide-up crm-form-wrapper crm-form-new" }
const _hoisted_135 = { class: "form-close" }
const _hoisted_136 = { class: "qc-item-wrap crm-item-wrap crm-item-wrap-bare" }
const _hoisted_137 = { class: "meeting-share-hint" }
const _hoisted_138 = { class: "meeting-share-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_meetings_home = _resolveComponent("meetings-home")!
  const _component_ai_meeting_recorder = _resolveComponent("ai-meeting-recorder")!
  const _component_ai_meeting_status = _resolveComponent("ai-meeting-status")!
  const _component_ai_meeting_recap = _resolveComponent("ai-meeting-recap")!
  const _component_scorecard_view = _resolveComponent("scorecard-view")!
  const _component_rocks_view = _resolveComponent("rocks-view")!
  const _component_edit_columns_panel = _resolveComponent("edit-columns-panel")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_add_edit_meeting = _resolveComponent("add-edit-meeting")!
  const _component_add_edit_meeting_item = _resolveComponent("add-edit-meeting-item")!
  const _component_move_column_prompt = _resolveComponent("move-column-prompt")!
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_forge_team = _resolveComponent("forge-team")!
  const _component_select_meeting_attendees = _resolveComponent("select-meeting-attendees")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[94] || (_cache[94] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Team"),
        _createElementVNode("div", { class: "page-bar-main" }, "Meetings")
      ])
    ], -1)),
    (!_ctx.$store.state.user.teamHubEmployee)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[62] || (_cache[62] = _createElementVNode("strong", null, "Your login needs a linked employee profile to use Meetings.", -1)),
          _cache[63] || (_cache[63] = _createElementVNode("p", null, "Employees may already exist, but one must match your login in this company. Ask a Team Hub administrator to check your employee profile's email for an admin login, or phone number for a phone login.", -1)),
          (_ctx.$store.state.user.email)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Signed in as " + _toDisplayString(_ctx.$store.state.user.email), 1))
            : _createCommentVNode("", true),
          (_ctx.$store.state.user.teamHubRole === 'Admin')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/employees"
              }, {
                default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                  _createTextVNode("Open Employees", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _cache[64] || (_cache[64] = _createElementVNode("p", null, "After the profile is updated, refresh this page.", -1))
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.lastMeetingCapture && !_ctx.lastMeetingCapture.jobId && _ctx.lastMeetingCapture.meetingID === _ctx.activeMeetingID && !_ctx.showRunMeeting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[66] || (_cache[66] = _createTextVNode(" No recording was saved for this run.", -1)),
                (_ctx.lastMeetingCapture.reason)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.lastMeetingCapture.reason), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, { to: "/ai-hub#captures" }, {
                  default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                    _createTextVNode("My AI Captures", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["meeting-group", _ctx.activeGroup == 'home' ? 'active' : '']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectGroup('home')))
            }, "Home", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["meeting-group", _ctx.activeGroup == 'my' ? 'active' : '']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectGroup('my')))
            }, [...(_cache[67] || (_cache[67] = [
              _createElementVNode("svg", {
                class: "meeting-group-lock",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.4",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true"
              }, [
                _createElementVNode("rect", {
                  x: "4",
                  y: "11",
                  width: "16",
                  height: "10",
                  rx: "2"
                }),
                _createElementVNode("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" })
              ], -1),
              _createTextVNode("My Meetings", -1)
            ]))], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meetingGroups, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.name,
                class: _normalizeClass(["meeting-group", _ctx.activeGroup == group.name ? 'active' : '']),
                style: _normalizeStyle(_ctx.activeGroup == group.name ? { borderBottomColor: group.color } : {}),
                onClick: ($event: any) => (_ctx.selectGroup(group.name)),
                onContextmenu: ($event: any) => (_ctx.onGroupContextMenu($event, group))
              }, [
                _createElementVNode("span", {
                  class: "meeting-group-dot",
                  style: _normalizeStyle({ background: group.color })
                }, null, 4),
                _createTextVNode(_toDisplayString(group.name), 1)
              ], 46, _hoisted_6))
            }), 128)),
            (_ctx.$store.state.user.teamHubRole == 'Admin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", {
                    class: "meeting-addlink",
                    ref: "addGroupTrigger",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleAddGroup()), ["stop"]))
                  }, "+ Add Group", 512)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.activeGroup != 'home')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meetings, (meeting) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: meeting.ID,
                    class: _normalizeClass(["meeting-tab", _ctx.activeMeetingID == meeting.ID ? 'active' : '']),
                    onClick: ($event: any) => (_ctx.selectMeeting(meeting.ID))
                  }, [
                    _createTextVNode(_toDisplayString(meeting.Name), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.recurrenceLabel(meeting.RecurrenceType)), 1)
                  ], 10, _hoisted_9))
                }), 128)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", {
                    class: "meeting-addlink",
                    ref: "templatePickerTrigger",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.toggleTemplatePicker()), ["stop"]))
                  }, "+ New Meeting", 512)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", {
                    class: "meeting-addlink",
                    ref: "pastMeetingsTrigger",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.togglePastMeetings()), ["stop"]))
                  }, "Past Meetings", 512)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showAddGroup)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "meeting-menu-pop add-group-pop",
                style: _normalizeStyle(_ctx.addGroupPopupStyle)
              }, [
                _cache[70] || (_cache[70] = _createElementVNode("div", { class: "meeting-menu-head" }, "Add a meeting group", -1)),
                (!_ctx.availableTeams.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Every team already has a meeting group."))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newGroupName) = $event))
                      }, [
                        _cache[68] || (_cache[68] = _createElementVNode("option", {
                          value: "",
                          disabled: ""
                        }, "Choose a team", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTeams, (team) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: team,
                            value: team
                          }, _toDisplayString(team), 9, _hoisted_14))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.newGroupName]
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          type: "color",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newGroupColor) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.newGroupColor]
                        ]),
                        _cache[69] || (_cache[69] = _createElementVNode("span", null, "Group color", -1))
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["meeting-btn meeting-btn-light", !_ctx.newGroupName || _ctx.savingGroup ? 'disable-button' : '']),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addGroup()))
                      }, "Add", 2)
                    ], 64))
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.showGroupMenu && _ctx.groupMenuTarget)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "meeting-menu-pop group-edit-pop",
                style: _normalizeStyle(_ctx.groupMenuPopupStyle)
              }, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.groupMenuTarget.name), 1),
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "color",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editGroupColor) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.editGroupColor]
                  ]),
                  _cache[71] || (_cache[71] = _createElementVNode("span", null, "Group color", -1))
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["meeting-btn meeting-btn-light group-edit-btn", _ctx.savingGroupChange ? 'disable-button' : '']),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveGroupColor()))
                }, "Save Color", 2),
                _createElementVNode("div", {
                  class: "meeting-btn meeting-btn-light meeting-btn-danger group-edit-btn",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmDeleteGroup()))
                }, "Delete Group")
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.showPastMeetings)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "meeting-menu-pop past-meetings-pop",
                style: _normalizeStyle(_ctx.pastMeetingsPopupStyle)
              }, [
                _cache[72] || (_cache[72] = _createElementVNode("div", { class: "meeting-menu-head" }, "Past Meetings", -1)),
                (!_ctx.pastMeetingsLoaded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Loading…"))
                  : (!_ctx.pastMeetings.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, "No past meetings yet."))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pastMeetings, (m) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: m.ID,
                            class: "meeting-menu-item",
                            onClick: ($event: any) => (_ctx.selectPastMeeting(m))
                          }, [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(m.Name), 1),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.pastMeetingDateDisplay(m.Date)), 1)
                          ], 8, _hoisted_21))
                        }), 128))
                      ]))
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.showTemplatePicker)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: "meeting-menu-pop template-picker-pop",
                style: _normalizeStyle(_ctx.templatePickerPopupStyle)
              }, [
                _createElementVNode("div", _hoisted_24, "Create a meeting" + _toDisplayString(_ctx.activeGroup == 'my' ? '' : ` in ${_ctx.activeGroup}`), 1),
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meetingTemplates, (t) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: t.ID,
                      class: "meeting-template-item",
                      onClick: ($event: any) => (_ctx.selectTemplate(t))
                    }, [
                      _createElementVNode("span", {
                        class: "meeting-template-dot",
                        style: _normalizeStyle({ background: t.Color })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(t.Name), 1),
                        (t.Description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(t.Description), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_26))
                  }), 128)),
                  _createElementVNode("div", {
                    class: "meeting-template-item",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectTemplate(null)))
                  }, [...(_cache[73] || (_cache[73] = [
                    _createElementVNode("span", { class: "meeting-template-dot meeting-template-dot-custom" }, null, -1),
                    _createElementVNode("div", { class: "meeting-template-text" }, [
                      _createElementVNode("div", { class: "meeting-template-name" }, "Custom"),
                      _createElementVNode("div", { class: "meeting-template-desc" }, "Name it and add sections — each with its own timer.")
                    ], -1)
                  ]))])
                ]),
                (_ctx.$store.state.user.teamHubRole == 'Admin')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "meeting-template-manage",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.manageTemplates()))
                    }, "Manage Templates"))
                  : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.activeGroup == 'home')
            ? (_openBlock(), _createBlock(_component_meetings_home, {
                key: _ctx.homeKey,
                onOpenMeeting: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openFromHome($event))),
                onOpenGroup: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectGroup($event))),
                onOpenItem: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openItemFromHome($event)))
              }))
            : (!_ctx.meetings.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createTextVNode(" No meetings yet in " + _toDisplayString(_ctx.activeGroup == 'my' ? 'My Meetings' : _ctx.activeGroup) + ". Use ", 1),
                  _cache[74] || (_cache[74] = _createElementVNode("b", null, "+ New Meeting", -1)),
                  _cache[75] || (_cache[75] = _createTextVNode(" to add one. ", -1))
                ]))
              : (_ctx.activeMeetingID && _ctx.meetingLoaded)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 8,
                    class: _normalizeClass(_ctx.showRunMeeting ? 'run-meeting-overlay' : '')
                  }, [
                    (_ctx.showRunMeeting)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.activeMeeting.Name), 1),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["run-meeting-stat-time", _ctx.isSectionOverTime ? 'over' : ''])
                                }, _toDisplayString(_ctx.currentSectionTimeDisplay), 3),
                                _createElementVNode("div", _hoisted_35, _toDisplayString((_ctx.currentRunSection.name || '').toUpperCase()), 1)
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.timeLeftDisplay), 1),
                                _cache[76] || (_cache[76] = _createElementVNode("div", { class: "run-meeting-stat-label" }, "Time Left", -1))
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.currentRunSection.name), 1),
                                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.currentRunSection.description), 1)
                              ])
                            ]),
                            (_ctx.showsRecorder)
                              ? _withDirectives((_openBlock(), _createBlock(_component_ai_meeting_recorder, {
                                  class: "run-meeting-recorder",
                                  ref: "meetingRecorder",
                                  onReady: _cache[16] || (_cache[16] = jobId => _ctx.lastMeetingCapture = { jobId, meetingID: _ctx.activeMeetingID }),
                                  controlled: "",
                                  key: _ctx.activeMeetingID,
                                  "meeting-id": _ctx.activeMeetingID,
                                  "history-id": _ctx.currentHistory?.ID,
                                  "run-skipped": !!_ctx.currentHistory?.RecordingSkipped
                                }, null, 8, ["meeting-id", "history-id", "run-skipped"])), [
                                  [_vShow, !(_ctx.meetingStarted && _ctx.hideRecorder)]
                                ])
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_41, [
                              (!_ctx.meetingStarted)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["run-meeting-btn run-meeting-btn-attend", _ctx.startingMeeting ? 'disable-button' : '']),
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showSelectAttendees = true))
                                  }, "Start Meeting", 2))
                                : _createCommentVNode("", true),
                              (_ctx.meetingStarted && _ctx.showsRecorder)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "run-meeting-btn",
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.hideRecorder = !_ctx.hideRecorder))
                                  }, _toDisplayString(_ctx.hideRecorder ? 'Show Recording' : 'Hide Recording'), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: "run-meeting-btn",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.nextSection()))
                              }, "Next"),
                              _cache[77] || (_cache[77] = _createElementVNode("div", { class: "run-meeting-btn" }, "Edit", -1)),
                              (!_ctx.meetingStarted)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "run-meeting-btn run-meeting-btn-end",
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.closeRunMeeting()))
                                  }, "Back"))
                                : (_ctx.endingMeeting)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Ending…"))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 4,
                                      class: "run-meeting-btn run-meeting-btn-end",
                                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showEndPanel = true))
                                    }, "End meeting"))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meetingSections, (section, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: _normalizeClass(["run-meeting-section-card", i == _ctx.activeSectionIndex ? 'active' : '']),
                                onClick: ($event: any) => (_ctx.selectRunSection(i))
                              }, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("span", _hoisted_46, _toDisplayString(i + 1), 1),
                                  _createElementVNode("span", _hoisted_47, _toDisplayString(section.minutes) + "m", 1)
                                ]),
                                _createElementVNode("div", _hoisted_48, _toDisplayString(section.name), 1)
                              ], 10, _hoisted_44))
                            }), 128))
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          (_ctx.viewingPastMeeting)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _cache[78] || (_cache[78] = _createTextVNode(" Viewing a past meeting ", -1)),
                                _createElementVNode("span", {
                                  class: "meeting-past-banner-back",
                                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.exitPastMeeting()))
                                }, "← Back to current meetings")
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_51, [
                            (_ctx.bigDate.md)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.bigDate.dow), 1),
                                  _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.bigDate.md), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_55, [
                              (_ctx.activeMeetingID && !_ctx.showRunMeeting && ['Admin', 'Editor'].includes(_ctx.$store.state.user.role))
                                ? (_openBlock(), _createBlock(_component_ai_meeting_status, {
                                    key: 0,
                                    "meeting-id": _ctx.activeMeetingID,
                                    class: "meeting-title-recording-status"
                                  }, null, 8, ["meeting-id"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_56, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "meeting-name-input",
                                  type: "text",
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.Name) = $event)),
                                  onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.saveMeetingData(true)))
                                }, null, 544), [
                                  [_vModelText, _ctx.formData.Name]
                                ]),
                                (!_ctx.activeMeeting.Team)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_57, "Private"))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "meeting-team-pill",
                                      style: _normalizeStyle(_ctx.teamPillStyle)
                                    }, _toDisplayString(_ctx.activeMeeting.Team), 5)),
                                (_ctx.headerAvatars.length)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerAvatars.slice(0, 3), (av) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: av.id,
                                          class: "meeting-avatar",
                                          title: av.name
                                        }, _toDisplayString(av.initials), 9, _hoisted_59))
                                      }), 128)),
                                      (_ctx.headerAvatars.length > 3)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "meeting-avatar meeting-avatar-more",
                                            title: _ctx.headerAvatars.slice(3).map(av => av.name).join(', ')
                                          }, "+" + _toDisplayString(_ctx.headerAvatars.length - 3), 9, _hoisted_60))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.recurrenceLabel(_ctx.activeMeeting.RecurrenceType)), 1),
                                (_ctx.timeDisplay)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[79] || (_cache[79] = _createTextVNode(" · ", -1)),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(_ctx.activeMeeting.StartTime ? 'meeting-time' : 'meeting-time meeting-time-none')
                                      }, _toDisplayString(_ctx.timeDisplay), 3)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_ctx.upcomingDates.length)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[80] || (_cache[80] = _createTextVNode(" · ", -1)),
                                      _cache[81] || (_cache[81] = _createElementVNode("span", { class: "meeting-uplbl" }, "Upcoming", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingDates, (d, i) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: i,
                                          class: "meeting-upchip"
                                        }, _toDisplayString(d), 1))
                                      }), 128))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.totalLengthDisplay), 1),
                              _createElementVNode("div", {
                                class: "meeting-btn meeting-btn-run",
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.openRunMeeting()))
                              }, _toDisplayString(_ctx.currentHistory ? 'Join Meeting' : 'Run Meeting'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(_ctx.activeTab == 'board' ? 'on' : ''),
                                onClick: _cache[26] || (_cache[26] = () => { _ctx.activeTab = 'board'; _ctx.viewingRecap = null; })
                              }, "Board", 2),
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(_ctx.activeTab == 'history' ? 'on' : ''),
                                onClick: _cache[27] || (_cache[27] = () => { _ctx.activeTab = 'history'; _ctx.viewingRecap = null; })
                              }, "History", 2)
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              (!_ctx.viewingPastMeeting)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "meeting-btn meeting-btn-forge",
                                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showForge = true))
                                  }, [
                                    _cache[82] || (_cache[82] = _createElementVNode("svg", {
                                      "aria-hidden": "true",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 24 24",
                                      fill: "currentColor",
                                      "fill-rule": "evenodd"
                                    }, [
                                      _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
                                    ], -1)),
                                    _createTextVNode(_toDisplayString(_ctx.forgeKinds.includes('prepl10') ? 'Prep for my meeting' : 'Improve my meeting'), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: "meeting-btn meeting-btn-light",
                                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.openEditMeeting()))
                              }, "Edit Meeting"),
                              _createElementVNode("div", {
                                class: "meeting-btn meeting-btn-light",
                                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.openShareAgenda()))
                              }, "Share Agenda"),
                              _createElementVNode("div", {
                                class: "meeting-btn meeting-btn-light",
                                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.editColumns = !_ctx.editColumns))
                              }, _toDisplayString(_ctx.editColumns ? 'Hide Columns' : 'Edit Columns'), 1),
                              (_ctx.canDeleteActiveMeeting)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "meeting-btn meeting-btn-light meeting-btn-danger",
                                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.showConfirmDeleteMeeting = true))
                                  }, " Delete Meeting "))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])),
                    _createElementVNode("div", _hoisted_68, [
                      (_ctx.activeTab == 'history')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.viewingRecap)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", {
                                    class: "meeting-recap-back",
                                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.viewingRecap = null))
                                  }, "← Back to history"),
                                  _createElementVNode("div", _hoisted_69, [
                                    (['Admin', 'Editor'].includes(_ctx.$store.state.user.role))
                                      ? (_openBlock(), _createBlock(_component_ai_meeting_recap, {
                                          key: 0,
                                          "history-id": _ctx.viewingRecap.ID
                                        }, null, 8, ["history-id"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.activeMeeting.Name), 1),
                                    _createElementVNode("div", _hoisted_71, [
                                      _createTextVNode(_toDisplayString(_ctx.historyDateDisplay(_ctx.viewingRecap.StartDate)) + " · " + _toDisplayString(_ctx.historyAttendeeCount(_ctx.viewingRecap)) + " attendees", 1),
                                      (_ctx.viewingRecap.Rating)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(" · rated " + _toDisplayString(_ctx.viewingRecap.Rating) + "/10", 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _cache[84] || (_cache[84] = _createElementVNode("div", { class: "meeting-recap-label" }, "Attendees", -1)),
                                    _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.recapAttendeeNames(_ctx.viewingRecap)), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recapBoard(_ctx.viewingRecap), (col, i) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                        (col.items && col.items.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                              _createElementVNode("div", _hoisted_74, [
                                                _createElementVNode("span", {
                                                  class: "meeting-recap-col-dot",
                                                  style: _normalizeStyle({ background: col.color })
                                                }, null, 4),
                                                _createTextVNode(_toDisplayString(col.name), 1)
                                              ]),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.items, (item, j) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "meeting-recap-item",
                                                  key: j
                                                }, [
                                                  _createElementVNode("div", _hoisted_75, [
                                                    _createElementVNode("span", _hoisted_76, [
                                                      _createTextVNode(_toDisplayString(item.Name), 1),
                                                      (item.Private)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_77, [...(_cache[83] || (_cache[83] = [
                                                            _createElementVNode("svg", {
                                                              class: "meeting-private-icon",
                                                              viewBox: "0 0 24 24",
                                                              fill: "none",
                                                              stroke: "currentColor",
                                                              "stroke-width": "2.4",
                                                              "stroke-linecap": "round",
                                                              "stroke-linejoin": "round"
                                                            }, [
                                                              _createElementVNode("rect", {
                                                                x: "4",
                                                                y: "11",
                                                                width: "16",
                                                                height: "10",
                                                                rx: "2"
                                                              }),
                                                              _createElementVNode("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" })
                                                            ], -1),
                                                            _createTextVNode("Only you", -1)
                                                          ]))]))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    (_ctx.employeeName(item.AssigneeEmployeeID))
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(_ctx.employeeName(item.AssigneeEmployeeID)), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (item.Comments && item.Comments.length)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Comments, (c, k) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            class: "meeting-recap-item-comment",
                                                            key: k
                                                          }, [
                                                            _createElementVNode("span", _hoisted_80, _toDisplayString(c.AuthorName || 'Unknown') + ":", 1),
                                                            _createTextVNode(" " + _toDisplayString(c.Comment), 1)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128)),
                                    (!_ctx.historyActionItemCount(_ctx.viewingRecap))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, "No action items were recorded for this meeting."))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (!_ctx.meetingHistory.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, "No meeting history yet."))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.meetingHistory, (h, i) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "meeting-history-row",
                                          key: i,
                                          onClick: ($event: any) => (_ctx.viewingRecap = h)
                                        }, [
                                          _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.historyDateDisplay(h.StartDate)), 1),
                                          _createElementVNode("div", _hoisted_85, [
                                            _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.activeMeeting.Name), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_87, [
                                            _createElementVNode("div", null, _toDisplayString(_ctx.historyAttendeeCount(h)) + " attendees", 1),
                                            _createElementVNode("div", null, _toDisplayString(_ctx.historyActionItemCount(h)) + " action items", 1),
                                            (h.Rating)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_88, "Rated " + _toDisplayString(h.Rating) + "/10", 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_89, [
                                            (['Admin', 'Editor'].includes(_ctx.$store.state.user.role))
                                              ? (_openBlock(), _createBlock(_component_ai_meeting_recap, {
                                                  key: 0,
                                                  "history-id": h.ID,
                                                  "links-only": ""
                                                }, null, 8, ["history-id"]))
                                              : _createCommentVNode("", true),
                                            _cache[85] || (_cache[85] = _createElementVNode("span", { class: "meeting-history-view" }, "View recap →", -1))
                                          ])
                                        ], 8, _hoisted_83))
                                      }), 128))
                                ], 64))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.runShowsScorecard)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                  _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.activeMeeting.Team) + " Scorecard", 1),
                                  (_openBlock(), _createBlock(_component_scorecard_view, {
                                    key: 'sc-' + _ctx.activeMeeting.Team,
                                    team: _ctx.activeMeeting.Team,
                                    meeting: _ctx.issueMeeting
                                  }, null, 8, ["team", "meeting"]))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.runShowsRocks)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                  _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.activeMeeting.Team) + " Rocks", 1),
                                  (_openBlock(), _createBlock(_component_rocks_view, {
                                    key: 'rk-' + _ctx.activeMeeting.Team,
                                    team: _ctx.activeMeeting.Team,
                                    meeting: _ctx.issueMeeting
                                  }, null, 8, ["team", "meeting"]))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.editColumns)
                              ? (_openBlock(), _createBlock(_component_edit_columns_panel, {
                                  key: 2,
                                  columns: _ctx.formData.Columns,
                                  onSave: _cache[34] || (_cache[34] = ($event: any) => (_ctx.saveMeetingData(false))),
                                  onCancel: _cache[35] || (_cache[35] = ($event: any) => (_ctx.cancelEditColumns())),
                                  onRemove: _ctx.removeCol,
                                  onAdd: _cache[36] || (_cache[36] = (col) => _ctx.formData.Columns.push(col))
                                }, null, 8, ["columns", "onRemove"]))
                              : _createCommentVNode("", true),
                            (!_ctx.runHidesBoard && _ctx.boardProgress.total)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                  _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.boardProgress.done) + " of " + _toDisplayString(_ctx.boardProgress.total) + " done", 1),
                                  _createElementVNode("div", {
                                    class: "meeting-progress-track",
                                    role: "progressbar",
                                    "aria-valuenow": _ctx.boardProgress.percent,
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100",
                                    "aria-label": "Items done"
                                  }, [
                                    _createElementVNode("div", {
                                      style: _normalizeStyle({ width: _ctx.boardProgress.percent + '%' })
                                    }, null, 4)
                                  ], 8, _hoisted_96),
                                  _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.boardProgress.percent) + "%", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (!_ctx.runHidesBoard)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.Columns, (col, i) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                      (col.show)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: i,
                                            class: "kanban-col kanban-col-tinted",
                                            style: _normalizeStyle({ '--col-color': col.color })
                                          }, [
                                            _createElementVNode("div", _hoisted_99, [
                                              _createElementVNode("span", {
                                                class: "kanban-coldot",
                                                style: _normalizeStyle({ background: col.color })
                                              }, null, 4),
                                              _createElementVNode("span", _hoisted_100, _toDisplayString(col.name), 1),
                                              _createElementVNode("span", {
                                                class: "kanban-coladd",
                                                title: "Add item",
                                                onClick: ($event: any) => (_ctx.addEditItem(col.name, null))
                                              }, [
                                                _createVNode(_component_svg_icon, { icon: "plus" })
                                              ], 8, _hoisted_101),
                                              _createElementVNode("span", _hoisted_102, _toDisplayString((_ctx.itemsByColumn[col.name] || []).length), 1),
                                              _createVNode(_component_svg_icon, {
                                                onClick: ($event: any) => (col.show = false),
                                                icon: "arrowsin",
                                                class: "kanban-colcollapse"
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _createElementVNode("div", _hoisted_103, [
                                              _createVNode(_component_draggable, {
                                                class: "kanban-cards",
                                                list: _ctx.itemsByColumn[col.name],
                                                group: "column",
                                                sort: false,
                                                onChange: ($event: any) => (_ctx.dragEnd($event, col.name)),
                                                animation: 150,
                                                "ghost-class": "kanban-ghost",
                                                "empty-insert-threshold": 40,
                                                "force-auto-scroll-fallback": true,
                                                "scroll-sensitivity": 120,
                                                "scroll-speed": 20,
                                                delay: 200,
                                                "delay-on-touch-only": true,
                                                "touch-start-threshold": 5
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsByColumn[col.name], (item) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: item.ID,
                                                      class: _normalizeClass(["meeting-card", item.Completed ? 'meeting-card-done' : '']),
                                                      onClick: ($event: any) => (_ctx.addEditItem(null, item))
                                                    }, [
                                                      _createElementVNode("div", _hoisted_105, [
                                                        _createElementVNode("input", {
                                                          type: "checkbox",
                                                          checked: item.Completed,
                                                          onClick: _cache[37] || (_cache[37] = _withModifiers(() => {}, ["stop"])),
                                                          title: item.Completed ? 'Completed' : 'Mark completed',
                                                          onChange: ($event: any) => (_ctx.toggleItemComplete(item, $event))
                                                        }, null, 40, _hoisted_106),
                                                        _createTextVNode(_toDisplayString(item.Name), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_107, [
                                                        (item.DueDate)
                                                          ? (_openBlock(), _createElementBlock("span", {
                                                              key: 0,
                                                              class: _normalizeClass(["meeting-due", _ctx.isItemOverdue(item) ? 'overdue' : ''])
                                                            }, [
                                                              _createVNode(_component_svg_icon, { icon: "clock" }),
                                                              _createTextVNode(_toDisplayString(_ctx.dueDateLabel(item.DueDate)), 1)
                                                            ], 2))
                                                          : _createCommentVNode("", true),
                                                        (item.Priority)
                                                          ? (_openBlock(), _createElementBlock("span", {
                                                              key: 1,
                                                              class: _normalizeClass(["meeting-pri", item.Priority])
                                                            }, _toDisplayString(_ctx.priorityLabel(item.Priority)), 3))
                                                          : _createCommentVNode("", true),
                                                        (item.Private)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_108, [...(_cache[86] || (_cache[86] = [
                                                              _createElementVNode("svg", {
                                                                class: "meeting-private-icon",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                "stroke-width": "2.4",
                                                                "stroke-linecap": "round",
                                                                "stroke-linejoin": "round"
                                                              }, [
                                                                _createElementVNode("rect", {
                                                                  x: "4",
                                                                  y: "11",
                                                                  width: "16",
                                                                  height: "10",
                                                                  rx: "2"
                                                                }),
                                                                _createElementVNode("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" })
                                                              ], -1),
                                                              _createTextVNode("Only you", -1)
                                                            ]))]))
                                                          : _createCommentVNode("", true),
                                                        (item.TaskManagerOwners && item.TaskManagerOwners.length)
                                                          ? (_openBlock(), _createElementBlock("span", {
                                                              key: 3,
                                                              class: "meeting-on-tasks",
                                                              title: 'On task manager: ' + item.TaskManagerOwners.join(', ')
                                                            }, [
                                                              _createVNode(_component_svg_icon, { icon: "checklist" }),
                                                              _createTextVNode(_toDisplayString(_ctx.taskManagerFirstNames(item.TaskManagerOwners)), 1)
                                                            ], 8, _hoisted_109))
                                                          : _createCommentVNode("", true),
                                                        (item.HomeMeeting)
                                                          ? (_openBlock(), _createElementBlock("span", {
                                                              key: 4,
                                                              class: "meeting-on-tasks",
                                                              title: 'Mirrored from ' + item.HomeMeeting.Name
                                                            }, [
                                                              _createVNode(_component_svg_icon, { icon: "copy" }),
                                                              _createTextVNode(_toDisplayString(item.HomeMeeting.Name), 1)
                                                            ], 8, _hoisted_110))
                                                          : (item.MirrorMeetings && item.MirrorMeetings.length)
                                                            ? (_openBlock(), _createElementBlock("span", {
                                                                key: 5,
                                                                class: "meeting-on-tasks",
                                                                title: 'Also on ' + item.MirrorMeetings.map((m) => m.Name).join(', ')
                                                              }, [
                                                                _createVNode(_component_svg_icon, { icon: "copy" }),
                                                                _createTextVNode(_toDisplayString(item.MirrorMeetings.length), 1)
                                                              ], 8, _hoisted_111))
                                                            : _createCommentVNode("", true),
                                                        (_ctx.assigneeInitials(item.AssigneeEmployeeID))
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(_ctx.assigneeInitials(item.AssigneeEmployeeID)), 1))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ], 10, _hoisted_104))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["list", "onChange"]),
                                              _createElementVNode("span", {
                                                class: "kanban-addbtn",
                                                onClick: ($event: any) => (_ctx.addEditItem(col.name, null))
                                              }, "+ Add item", 8, _hoisted_113)
                                            ])
                                          ], 4))
                                        : (_openBlock(), _createElementBlock("div", {
                                            class: "kanban-col kanban-col-collapsed kanban-col-tinted",
                                            key: 'a'+i,
                                            style: _normalizeStyle({ '--col-color': col.color }),
                                            onClick: ($event: any) => (col.show = true)
                                          }, [
                                            _createVNode(_component_svg_icon, {
                                              icon: "arrowsout",
                                              class: "kanban-colcollapse"
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(col.name), 1)
                                          ], 12, _hoisted_114))
                                    ], 64))
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                    ])
                  ], 2))
                : _createCommentVNode("", true),
          (_ctx.showMeetingForm)
            ? (_openBlock(), _createBlock(_component_add_edit_meeting, {
                key: 9,
                group: _ctx.activeGroup,
                meeting: _ctx.meetingFormMeeting,
                template: _ctx.meetingFormTemplate,
                onClose: _cache[38] || (_cache[38] = ($event: any) => (_ctx.showMeetingForm = false)),
                onCreated: _ctx.meetingCreated,
                onUpdated: _ctx.meetingUpdated
              }, null, 8, ["group", "meeting", "template", "onCreated", "onUpdated"]))
            : _createCommentVNode("", true),
          (_ctx.showEndPanel && _ctx.showRunMeeting && _ctx.currentHistory)
            ? (_openBlock(), _createElementBlock("div", {
                key: 10,
                class: "error-msg-wrap",
                onClick: _cache[44] || (_cache[44] = _withModifiers(($event: any) => (_ctx.closeEndPanel()), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    _cache[87] || (_cache[87] = _createElementVNode("div", { class: "run-end-title" }, "End of Meeting", -1)),
                    _createElementVNode("div", _hoisted_117, _toDisplayString(_ctx.activeMeeting.Name) + " · " + _toDisplayString(_ctx.runDateDisplay), 1),
                    _createElementVNode("span", {
                      class: "run-end-x",
                      title: "Close",
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.closeEndPanel()))
                    }, [
                      _createVNode(_component_svg_icon, { icon: "x" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      _cache[88] || (_cache[88] = _createTextVNode("New To-Dos", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.newTodos.length ? _ctx.newTodos.length + ' added this meeting' : 'Nothing added this meeting'), 1)
                    ]),
                    (_ctx.newTodos.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newTodos, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.ID,
                              class: "run-end-todo",
                              onClick: ($event: any) => (_ctx.addEditItem(null, item))
                            }, [
                              _createElementVNode("span", _hoisted_122, _toDisplayString(item.Name), 1),
                              (item.AssigneeEmployeeID)
                                ? (_openBlock(), _createElementBlock("b", _hoisted_123, _toDisplayString(_ctx.firstName(_ctx.employeeName(item.AssigneeEmployeeID))), 1))
                                : _createCommentVNode("", true),
                              (item.DueDate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_124, _toDisplayString(_ctx.dueDayDisplay(item.DueDate)), 1))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_121))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _cache[89] || (_cache[89] = _createElementVNode("div", { class: "run-end-h" }, [
                      _createTextVNode("Rate the Meeting"),
                      _createElementVNode("span", null, "The team agrees on one score · goal 8+")
                    ], -1)),
                    _createElementVNode("div", _hoisted_125, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                        return _createElementVNode("button", {
                          key: n,
                          type: "button",
                          role: "radio",
                          "aria-checked": _ctx.currentHistory.Rating == n,
                          class: _normalizeClass(["run-end-rate", _ctx.currentHistory.Rating == n ? 'on' : '']),
                          onClick: ($event: any) => (_ctx.rateMeeting(n))
                        }, _toDisplayString(n), 11, _hoisted_126)
                      }), 64))
                    ])
                  ]),
                  (_ctx.confirmEnd && !_ctx.endingMeeting)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                        _cache[90] || (_cache[90] = _createElementVNode("span", { class: "run-end-ask" }, "Stop the recording and end the meeting?", -1)),
                        _createElementVNode("div", _hoisted_128, [
                          _createElementVNode("div", {
                            class: "btn btn-light run-end-btn",
                            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.confirmEnd = false))
                          }, "No"),
                          _createElementVNode("div", {
                            class: "btn run-end-btn",
                            onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.endMeeting()))
                          }, "Yes")
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_129, [
                        _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.lastRating ? 'Last meeting: ' + _ctx.lastRating : ''), 1),
                        _createElementVNode("div", _hoisted_131, [
                          _createElementVNode("div", {
                            class: "btn btn-light run-end-btn",
                            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.closeEndPanel()))
                          }, "Cancel"),
                          _createElementVNode("div", {
                            class: _normalizeClass(["btn run-end-btn", !_ctx.currentHistory.Rating || _ctx.endingMeeting ? 'disable-button' : '']),
                            title: _ctx.currentHistory.Rating ? '' : 'Rate the meeting first',
                            onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.askEndMeeting()))
                          }, _toDisplayString(_ctx.endingMeeting ? 'Ending…' : 'End Meeting'), 11, _hoisted_132)
                        ])
                      ]))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showAddEditItem)
            ? (_openBlock(), _createBlock(_component_add_edit_meeting_item, {
                key: 11,
                ref: "addEditItemModal",
                item: _ctx.addEditData,
                employees: _ctx.itemAssigneeOptions,
                columns: _ctx.columnNames,
                onMoveColumn: _cache[45] || (_cache[45] = ($event: any) => (_ctx.moveItemToColumn(_ctx.addEditData.ID, $event))),
                onClose: _cache[46] || (_cache[46] = ($event: any) => (_ctx.closeAddEdit())),
                onOpenElsewhere: _cache[47] || (_cache[47] = ($event: any) => (_ctx.openMirroredItem($event)))
              }, null, 8, ["item", "employees", "columns"]))
            : _createCommentVNode("", true),
          (_ctx.completedMove)
            ? (_openBlock(), _createBlock(_component_move_column_prompt, {
                key: 12,
                message: "Marked completed.",
                columns: _ctx.columnNames,
                current: _ctx.completedMove.current,
                "default-column": _ctx.completedMove.column,
                onMove: _cache[48] || (_cache[48] = ($event: any) => {_ctx.moveItemToColumn(_ctx.completedMove.itemID, $event); _ctx.completedMove = null}),
                onCancel: _cache[49] || (_cache[49] = ($event: any) => (_ctx.completedMove = null))
              }, null, 8, ["columns", "current", "default-column"]))
            : _createCommentVNode("", true),
          (_ctx.shareAgenda)
            ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "form-close-x",
                      title: "Close",
                      onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.shareAgenda = null))
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("div", null, [
                      _cache[91] || (_cache[91] = _createElementVNode("h3", { class: "quick-add-heading" }, "Share Agenda", -1)),
                      _createElementVNode("p", _hoisted_137, _toDisplayString(_ctx.activeMeeting.Name) + _toDisplayString(_ctx.agendaLabels.DateLabel ? ' · ' + _ctx.agendaLabels.DateLabel : '') + ". Sent as a PDF: attached to the email, and as a link by text. The link works for 30 days.", 1),
                      _cache[92] || (_cache[92] = _createElementVNode("div", { class: "crm-item-label" }, "Email", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        style: {"margin":"0"},
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.shareAgenda.email) = $event)),
                        placeholder: "Email"
                      }, null, 512), [
                        [_vModelText, _ctx.shareAgenda.email]
                      ]),
                      _cache[93] || (_cache[93] = _createElementVNode("div", { class: "crm-item-label" }, "Phone", -1)),
                      _createVNode(_component_phone_input, {
                        modelValue: _ctx.shareAgenda.phone,
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.shareAgenda.phone) = $event)),
                        placeholder: "Phone"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_138, [
                        _createElementVNode("a", {
                          class: "meeting-share-preview",
                          onClick: _cache[53] || (_cache[53] = _withModifiers(($event: any) => (_ctx.previewAgenda()), ["prevent"]))
                        }, "Preview PDF"),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["btn", _ctx.shareAgenda.sending ? 'disable-button' : '']),
                          onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.sendAgenda()))
                        }, "Send", 2)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.agendaPDFUrl)
            ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
                key: 14,
                url: _ctx.agendaPDFUrl,
                onClose: _cache[55] || (_cache[55] = ($event: any) => (_ctx.agendaPDFUrl = ''))
              }, null, 8, ["url"]))
            : _createCommentVNode("", true),
          (_ctx.showConfirmDeleteMeeting)
            ? (_openBlock(), _createBlock(_component_confirm_delete, {
                key: 15,
                onConfirm: _ctx.deleteMeetingConfirm,
                onCancel: _cache[56] || (_cache[56] = () => { _ctx.showConfirmDeleteMeeting = false; }),
                msg: "Are you sure you would like to delete this meeting? This cannot be undone."
              }, null, 8, ["onConfirm"]))
            : _createCommentVNode("", true),
          (_ctx.showConfirmDeleteGroup)
            ? (_openBlock(), _createBlock(_component_confirm_delete, {
                key: 16,
                onConfirm: _ctx.deleteGroupConfirm,
                onCancel: _cache[57] || (_cache[57] = () => { _ctx.showConfirmDeleteGroup = false; _ctx.groupMenuTarget = null; }),
                msg: `Are you sure you would like to delete the '${_ctx.groupMenuTarget && _ctx.groupMenuTarget.name}' meeting group? Meetings already in it won't be deleted, but they'll no longer appear under a group tab.`
              }, null, 8, ["onConfirm", "msg"]))
            : _createCommentVNode("", true),
          (_ctx.showForge && _ctx.activeMeeting)
            ? (_openBlock(), _createBlock(_component_forge_team, {
                key: 17,
                modal: "",
                only: _ctx.forgeKinds,
                "start-kind": _ctx.forgeKinds[0],
                meeting: _ctx.forgeMeeting,
                onApplied: _cache[58] || (_cache[58] = ($event: any) => (_ctx.loadItems())),
                onClose: _cache[59] || (_cache[59] = ($event: any) => (_ctx.showForge = false))
              }, null, 8, ["only", "start-kind", "meeting"]))
            : _createCommentVNode("", true),
          (_ctx.showSelectAttendees)
            ? (_openBlock(), _createBlock(_component_select_meeting_attendees, {
                key: 18,
                employees: _ctx.teamEmployees,
                "attendee-ids": _ctx.runAttendeeIDs,
                "submit-label": "Start Meeting",
                onClose: _cache[60] || (_cache[60] = ($event: any) => (_ctx.showSelectAttendees = false)),
                onSave: _ctx.onSaveRunAttendees
              }, null, 8, ["employees", "attendee-ids", "onSave"]))
            : _createCommentVNode("", true)
        ], 64))
  ], 512))
}